import { render, staticRenderFns } from "./LogoUpload.vue?vue&type=template&id=5dba764e&scoped=true&"
import script from "./LogoUpload.vue?vue&type=script&lang=js&"
export * from "./LogoUpload.vue?vue&type=script&lang=js&"
import style0 from "./LogoUpload.vue?vue&type=style&index=0&id=5dba764e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dba764e",
  null
  
)

export default component.exports